<!--
 * @Description: 发票管理
 *               工业只有开票备案
                 服务商有未开票 开票记录（查看、审核） 发票备案
                 供应商有未开票（渠道服务费一种类型） 开票记录（补充、上传、审核） 
 * @Date: 2025-06-11 16:21:13
-->
<template>
  <div>
    <div class="table__card" v-if="!isGy">
      <div
        class="table__card__item"
        v-for="item in statistics"
        :key="item.value"
      >
        <p class="table__card__item__label" :title="item.label">
          {{ item.label }}
        </p>
        <p class="table__card__item__value">{{ item.value }}</p>
      </div>
    </div>
    <BaseTabs style="margin: 10px 0" v-model="tab" v-if="tabs.length > 1">
      <BaseTabPane
        v-for="item in tabs"
        :label="item.label"
        :name="item.value"
        :key="item.value"
      ></BaseTabPane>
    </BaseTabs>
    <component :is="curCmopt" />
  </div>
</template>
<script lang="tsx" setup>
import { ref, onMounted, computed } from 'vue';
import { BaseTabs, BaseTabPane } from 'xrk-components';

import { summarizeTheInvoiceInformation } from '@V/invoice/src/data-source/apis';
import { formatter } from '@/utils';
import { useRouteMeta } from '@hooks/common';
import { TABS } from '@V/invoice/src/constants';
import { RouteQuery } from '@V/invoice/src/types';
import { useRoute } from 'vue-router';
import appStore from '@/store';
import { storeToRefs } from 'pinia';
import { IS_PLATFORM_TYPE_1 } from '@/config';

const route = useRoute();
const routeMeta = useRouteMeta();
const { info: userInfo } = storeToRefs(appStore.useUserStoreSetup);

const routeQuery = route.query as RouteQuery;
const isAsp = [2].includes(+routeMeta.functionCode);
const isSupplier = [3].includes(+routeMeta.functionCode);
const isGy = [1].includes(+routeMeta.functionCode);

const tab = ref();
const statistics = ref({
  amountToBeInvoiced: {
    label: '待开票金额',
    value: '',
    key: 'amountToBeInvoiced'
  },
  amountToBeInvoicedNum: {
    label: '待开票订单笔数',
    value: '',
    key: 'amountToBeInvoicedNum'
  },
  monthlyInvoicingAmountToBeProcessed: {
    label: '月度待开票金额',
    value: '',
    key: 'monthlyInvoicingAmountToBeProcessed'
  },
  inTheProcessOfInvoicing: {
    label: '开票中',
    value: '',
    key: 'inTheProcessOfInvoicing'
  },
  annualCumulativeAmount: {
    label: '当年累计开票金额',
    value: '',
    key: 'annualCumulativeAmount'
  },
  annualCumulativeNum: {
    label: '当年累计开票数',
    value: '',
    key: 'annualCumulativeNum'
  },
  lastMonthAmount: {
    label: '上一个月度累计开票金额',
    value: '',
    key: 'lastMonthAmount'
  },
  lastMonthNum: {
    label: '上一个月度累计开票笔数',
    value: '',
    key: 'lastMonthNum'
  },
  redInkInvoiceNum: {
    label: '红冲发票数',
    value: '',
    key: 'redInkInvoiceNum'
  },
  redInkInvoiceAmount: {
    label: '红冲发票金额',
    value: '',
    key: 'redInkInvoiceAmount'
  }
});

const curCmopt = computed(() => {
  return TABS[tab.value]?.cmpt;
});
/* 对应角色设置tab */
const tabs = computed(() => {
  if (isAsp) {
    // 独立项目也没有个体发票上传
    if (userInfo.value.isBaseAsp === 1 && IS_PLATFORM_TYPE_1) {
      return [TABS[1], TABS[2], TABS[4], TABS[3]];
    }
    return [TABS[1], TABS[2], TABS[3]];
  }
  if (isSupplier) {
    return [TABS[1], TABS[2]];
  }
  if (isGy) {
    return [TABS[3]];
  }
  return [];
});

onMounted(async () => {
  tab.value = +routeQuery.tab ? +routeQuery.tab : tabs.value[0].value;
  if (!isGy) {
    const { data } = await summarizeTheInvoiceInformation();
    Object.keys(statistics.value).forEach(key => {
      if (
        [
          'amountToBeInvoiced',
          'monthlyInvoicingAmountToBeProcessed',
          'annualCumulativeAmount',
          'lastMonthAmount',
          'redInkInvoiceAmount'
        ].includes(key)
      ) {
        statistics.value[key].value = formatter.fen2yuan(data[key]);
      } else {
        statistics.value[key].value = data[key];
      }
    });
  }
});
</script>
